import { NotificationTypes } from "@lib/enums";
import {
  EmailOpenedIcon,
  PageViewedIcon,
  IsInterestedIcon,
  AskQuestionIcon,
  UnsubscribedIcon,
} from "./icons";

const Icons = {
  [NotificationTypes.EMAIL_OPENED]: EmailOpenedIcon,
  [NotificationTypes.EMAIL_BOUNCED]: UnsubscribedIcon,
  [NotificationTypes.EMAIL_UNSUBSCRIBED]: UnsubscribedIcon,
  [NotificationTypes.PAGE_VIEWED]: PageViewedIcon,
  [NotificationTypes.CANDIDATE_IS_INTERESTED]: IsInterestedIcon,
  [NotificationTypes.CANDIDATE_ASK_QUESTION]: AskQuestionIcon,
  [NotificationTypes.CANDIDATE_NOT_INTERESTED]: AskQuestionIcon,
  [NotificationTypes.CANDIDATE_BOOK_INTERVIEW]: IsInterestedIcon,
  [NotificationTypes.CANDIDATE_GIVE_FEEDBACK]: AskQuestionIcon,
  [NotificationTypes.CANDIDATE_VIEW_MORE]: PageViewedIcon,
};

export default function Icon({ type, size = 20 }) {
  const IconComponent = Icons[type] || EmailOpenedIcon;
  return <IconComponent size={size} />;
}
